export default function integrationauths(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        integrationauth: action.integrationauth,
      }
    default:
      return state;
  }
}
